
export const vgongBlockWrapperTemplate = (vgongBlockOptionalClasses) =>`
<div class="vgong-block ${vgongBlockOptionalClasses}" id="vgong-block">
    <h2 class="vgong-title"><a href="/vgong"><svg class="icon vgong-logo"><use xlink:href="#icon-vgong_logo"></use></svg></a></h2>
</div>
`